// extracted by mini-css-extract-plugin
export default {"indicatorCircle":"MicIndicatorCircle_indicatorCircle__y2tCM"};